module.exports = __webpack_public_path__ + "img/05-round-convex-3-4-base.d7abb1b7.svg";